import { render, staticRenderFns } from "./BabylonPanel.vue?vue&type=template&id=79c52fd4&scoped=true&"
import script from "./BabylonPanel.vue?vue&type=script&lang=js&"
export * from "./BabylonPanel.vue?vue&type=script&lang=js&"
import style0 from "./BabylonPanel.vue?vue&type=style&index=0&id=79c52fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c52fd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
